import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { brandName, differenceWith, differenceWithout, price } from '../data/copy';
export function FinalCtaSection() {
  return <section className="w-full bg-ink py-10 sm:py-14" aria-labelledby="final-cta-heading" data-id="element-67" data-mp="3qrouhlxcapze">
      <div className="mx-auto max-w-4xl px-6" data-id="element-68" data-mp="3vq9txj4rp5ms">
        <SectionHeading title={<span id="final-cta-heading" data-id="element-70" data-mp="2y6f4kemu79js">Your next futsal session</span>} data-id="element-69" data-mp="2y5nbbagppnwo" />

        <div className="mt-8 grid overflow-hidden rounded-3xl border border-line md:grid-cols-2" data-id="element-71" data-mp="3335ml7i7cf7u">
          <div className="bg-navy" data-id="element-72" data-mp="382rv53n357ab">
            <h3 className="border-b border-line px-5 py-3.5 font-display text-lg font-bold uppercase tracking-wide text-muted" data-id="element-73" data-mp="381qn781d90wt">
              Keep improvising
            </h3>
            <ul className="space-y-2 px-5 py-4" data-id="element-74" data-mp="2fdkzqdixgxta">
              {differenceWithout.map(item => <li key={item} className="flex items-start gap-2 text-[0.92rem] leading-snug text-muted" data-id="element-75" data-mp="2kcnvf7d0prol">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" strokeWidth={2.6} aria-hidden="true" data-id="element-76" data-mp="2dayozptnuy2u" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="border-t border-line bg-accent/[0.07] md:border-l md:border-t-0" data-id="element-77" data-mp="23lf5qj21d27g">
            <h3 className="border-b border-line px-5 py-3.5 font-display text-lg font-bold uppercase tracking-wide text-accent" data-id="element-78" data-mp="1ynngjwsrzu6y">
              {brandName}
            </h3>
            <ul className="space-y-2 px-5 py-4" data-id="element-79" data-mp="1uj5yq35z7qyt">
              {differenceWith.map(item => <li key={item} className="flex items-start gap-2 text-[0.92rem] font-medium leading-snug text-fg" data-id="element-80" data-mp="1pl4ehewtdllr">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-81" data-mp="1kp5v65qcets7" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-82" data-mp="3a29cmg8piqru">
          <p className="text-lg italic text-muted" data-id="element-83" data-mp="3a2showd9dkog">
            You do not need to be the perfect futsal coach.
          </p>
          <p className="mx-auto mt-2 max-w-xl text-xl font-medium leading-snug text-fg sm:text-2xl" data-id="element-84" data-mp="18ba822oa8qfw">
            You need a system that helps you{' '}
            <span className="font-bold text-accent" data-id="element-85" data-mp="yfyqlclhp54g">plan faster</span>, coach
            with <span className="font-bold text-accent" data-id="element-86" data-mp="13dh47gagc8is">more structure</span>,
            and give your players{' '}
            <span className="font-bold text-accent" data-id="element-87" data-mp="1r4mj9t8kiws1">more meaningful repetitions</span>.
          </p>

          <p className="mt-8 font-display text-3xl font-extrabold uppercase leading-[0.95] text-accent sm:text-5xl" data-id="element-88" data-mp="1w1mo60tolthk">
            Your next futsal session is already planned.
          </p>

          <CtaButton size="large" className="mt-7 w-full sm:w-auto" data-id="element-89" data-mp="1m3qhbl7s1kp9">
            Get {brandName} — {price}
          </CtaButton>
          <p className="mt-4 text-sm text-muted" data-id="element-90" data-mp="6m6hqt756lvd">
            Secure payment · Instant access · 7-day guarantee
          </p>
        </div>
      </div>
    </section>;
}